module.exports = __webpack_public_path__ + "img/mobil-02.45114ad5.jpg";